import { useCallback, useRef } from 'react'
import ClassNames from 'classnames'
import { useField, useFormikContext } from 'formik'

import { CryptoPaymentInputActionButton } from './CryptoPaymentInputActionButton'
import { isNullOrUndefined } from '../../../../services/helpers'

import classes from './styles/cryptoPaymentInput.module.scss'

export const CryptoPaymentInput = ({
  label,
  type,
  readOnly,
  afterInput,
  disabled,
  placeholder,
  className,
  inputClassName: inputFromPropsClassName,
  actionType = false,
  copyButtonClassName,
  onChange,
  format,
  formElement = true,
  isCombined = false,
  ...props
}) => {
  const inputType = type || 'text'
  const inputRef = useRef(null)

  const [field, meta] = useField(props)
  const { setFieldValue: setFieldValueFromFormik } = useFormikContext(props)

  const setFieldValue = useCallback(
    value => {
      setFieldValueFromFormik(field.name, value)
    },
    [field.name, setFieldValueFromFormik]
  )

  const getInputLabel = useCallback(() => {
    if (typeof label === 'string' || typeof label === 'number') {
      return label
    }

    if (typeof label === 'function') {
      return label()
    }

    return ''
  }, [label])

  const componentClassName = ClassNames(
    classes.cryptoPaymentInput,
    {
      formElement: formElement
    },
    className
  )

  const inputClassName = ClassNames(
    classes.cryptoPaymentInput__input,
    {
      [classes.cryptoPaymentInput__input_disabled]: disabled,
      [classes.cryptoPaymentInput__input_readOnly]: readOnly,
      [classes.cryptoPaymentInput__input_withActionButton]: actionType
    },
    inputFromPropsClassName
  )

  const handleChange = useCallback(
    e => {
      field.onChange(e)

      onChange && onChange(e.target.value)
    },
    [field, onChange]
  )

  const handleBlur = useCallback(
    e => {
      field.onBlur(e)

      const checkValue = value => {
        if (isNullOrUndefined(value) || Number(value) === 0 || value.trim() === '') {
          setFieldValue('')
          return true
        }
        return false
      }

      if (format) {
        const value = e.target.value

        if (checkValue(value)) return

        const formatedValue = format(value)

        if (checkValue(formatedValue)) return

        setFieldValue(formatedValue)
      }
    },
    [field, format, setFieldValue]
  )

  return (
    <div className={componentClassName}>
      {label && <div className={classes.cryptoPaymentInput__inputLabel}>{getInputLabel()}</div>}
      <div className={classes.cryptoPaymentInput__inputWrapper}>
        {afterInput && isNullOrUndefined(actionType) && (
          <div className={classes.cryptoPaymentInput__afterInput}>{afterInput}</div>
        )}
        <input
          ref={inputRef}
          type={inputType}
          disabled={disabled}
          readOnly={readOnly}
          placeholder={placeholder}
          className={inputClassName}
          {...field}
          // onChange and onBlur below overwrite Field (Formik); props keep order
          onChange={handleChange}
          onBlur={handleBlur}
        />
        {actionType && (
          <CryptoPaymentInputActionButton
            value={field.value}
            inputRef={inputRef}
            actionType={actionType}
            setFieldValue={setFieldValue}
            className={copyButtonClassName}
          />
        )}
      </div>
      {meta.error && meta.touched && !isCombined && (
        <div className={classes.cryptoPaymentInput__inputError}>{meta.error}</div>
      )}
    </div>
  )
}
